import { type FolderStruct } from '@kizen/kds/FoldersTree';
import type {
  AutomationOrFolder,
  Folder,
} from 'store/automationsPage/automations.redux';

export const isFolder = (item: AutomationOrFolder): item is Folder => {
  return 'parent_folder_id' in item;
};

export const checkNestedFoldersLevels = (
  folder: FolderStruct<Folder>,
  allowedLevel: number
): boolean => {
  if (folder.subfolders.length > 0) {
    if (allowedLevel <= 1) {
      return false;
    }
    return folder.subfolders.every((subfolder) =>
      checkNestedFoldersLevels(subfolder, allowedLevel - 1)
    );
  }
  return true;
};
